import { z } from 'zod'

export const myApplicationSearchSchema = z.object({
  page: z.coerce.number().int().min(1).catch(1),
  pageSize: z.coerce
    .number()
    .pipe(z.union([z.literal(10), z.literal(25), z.literal(50)]))
    .catch(10),
  sortBy: z.enum(['sent', 'org']).catch('sent'),
  direction: z.enum(['asc', 'desc']).catch('desc'),
})

export type MyApplicationSearch = z.infer<typeof myApplicationSearchSchema>

export const defaultMyApplicationSearch: MyApplicationSearch = {
  page: 1,
  pageSize: 10,
  sortBy: 'sent',
  direction: 'desc',
}
